// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleCard_container__yRiGd","header":"ArticleCard_header__KV5D0","link":"ArticleCard_link__sEOt8","footer":"ArticleCard_footer__RZXHr"};